module.exports = __webpack_public_path__ + "media/images/blue-photo-a968227811f79c794e31c8082f32cec8.jpg";